import CopyInput from "V2.0/common/CopyInput";

export default function CopyableWorkspaceId(props) {
  const { workspaceId } = props;

  return (
    <CopyInput
      value={workspaceId}
      title="Workspace ID"
    />
  );
}
